import { MutationTree } from 'vuex';
import { EEngagementVideoMutation } from './engagement-video.constants';
import { IEngagementVideoState } from './engagement-video.types';
import { IEngagementVideo } from '@lib-shared/types/engagement-video';
import { IVideo } from '@/types/Video';

export const mutations: MutationTree<IEngagementVideoState> = {
  [EEngagementVideoMutation.SetAdding](state: IEngagementVideoState, adding: boolean) {
    state.adding = adding;
  },
  [EEngagementVideoMutation.SetState](
    state: IEngagementVideoState,
    newState: IEngagementVideoState
  ) {
    Object.assign(state, newState);
  },
  [EEngagementVideoMutation.SetVideo](state: IEngagementVideoState, video: IEngagementVideo) {
    state.addedVideo = video;
  },
  [EEngagementVideoMutation.SetVideos](state: IEngagementVideoState, videos: IVideo[]) {
    state.videos = videos;
  },
  [EEngagementVideoMutation.SetLoading](state: IEngagementVideoState, loading: boolean) {
    state.loading = loading;
  },
  [EEngagementVideoMutation.SetLoaded](state: IEngagementVideoState, loaded: boolean) {
    state.loaded = loaded;
  },
  [EEngagementVideoMutation.Remove](state: IEngagementVideoState, videoId: string) {
    state.videos = state.videos.filter((video: IVideo) => video.videoId !== videoId);
  },
};
